"use client";
import { jsx as t, jsxs as s } from "react/jsx-runtime";
import { Shadow as I, RootProvider as m, WebWidgetInteractionType as g, EmbeddedSearch as e, useInkeepConfig as R, useModal as p, useWidget as w, dataAttr as u, useCommandState as h, Modal as A } from "@inkeep/cxkit-styled";
import { Fragment as d } from "react";
import { WidgetToggle as T, useToggleView as S } from "./widget-toggle.js";
import { ModalContent as v } from "./modal.js";
function F(n) {
  const { baseSettings: r, searchSettings: l } = n;
  return /* @__PURE__ */ t(I, { children: /* @__PURE__ */ t(
    m,
    {
      config: {
        baseSettings: r,
        searchSettings: l
      },
      componentType: g.EmbeddedSearch,
      children: /* @__PURE__ */ t(P, { ...n })
    }
  ) });
}
function k(n) {
  const { children: r, onToggleView: l, isHidden: o, shouldAutoFocusInput: i = !l } = n;
  return /* @__PURE__ */ t(e.Provider, { isHidden: o, shouldAutoFocusInput: i, children: r });
}
function P(n) {
  return /* @__PURE__ */ t(k, { ...n, children: /* @__PURE__ */ t(b, { ...n }) });
}
function b(n) {
  const {
    searchSettings: { view: r }
  } = R(), { onToggleView: l, shouldShowAskAICard: o = !!l && r !== "dual-pane" } = n, i = p(), c = w();
  return /* @__PURE__ */ t(i && !c ? v : d, { children: /* @__PURE__ */ t(
    e.Wrapper,
    {
      "data-show-ask-ai-card": u(o),
      "data-composite": u(!!l || i?.isOpen),
      children: /* @__PURE__ */ s(e.Root, { children: [
        /* @__PURE__ */ t(f, { ...n }),
        /* @__PURE__ */ s(e.Content, { children: [
          /* @__PURE__ */ t(
            L,
            {
              askAILabel: n.askAILabel,
              onToggleView: n.onToggleView,
              shouldShowAskAICard: o
            }
          ),
          /* @__PURE__ */ t(C, {})
        ] }),
        /* @__PURE__ */ t($, {})
      ] })
    }
  ) });
}
function f(n) {
  const { onToggleView: r, askAILabel: l, searchLabel: o } = n, i = h((c) => c.search);
  return /* @__PURE__ */ s(e.InputGroup, { children: [
    /* @__PURE__ */ t(e.InputIcon, {}),
    /* @__PURE__ */ t(e.Input, {}),
    /* @__PURE__ */ t(e.Loading, {}),
    r && /* @__PURE__ */ t(
      T,
      {
        onToggleView: r,
        query: i,
        askAILabel: l,
        searchLabel: o,
        view: "search"
      }
    ),
    /* @__PURE__ */ t(A.Close, {})
  ] });
}
function L(n) {
  const { askAILabel: r, onToggleView: l, shouldShowAskAICard: o } = n, i = h((a) => a.search), { handleToggle: c } = S({
    onToggleView: l,
    query: i
  });
  return o ? /* @__PURE__ */ s(e.AskAITrigger, { onSelect: () => c("chat", !0), children: [
    /* @__PURE__ */ t(e.AskAITriggerIcon, {}),
    /* @__PURE__ */ s(e.AskAITriggerLabel, { children: [
      r || "Ask AI",
      i && ` "${i}"`
    ] }),
    /* @__PURE__ */ t(e.AskAITriggerIndicator, {})
  ] }) : null;
}
function C() {
  return /* @__PURE__ */ s(e.Results, { children: [
    /* @__PURE__ */ t(e.ResultsLoading, {}),
    /* @__PURE__ */ t(e.ResultsTabList, { children: (n) => n.map((r) => /* @__PURE__ */ t(e.ResultsTab, { tab: r }, r)) }),
    /* @__PURE__ */ t(e.ResultsEmpty, {}),
    /* @__PURE__ */ s(e.ResultsContent, { children: [
      /* @__PURE__ */ t(V, {}),
      /* @__PURE__ */ t(O, {})
    ] })
  ] });
}
function V() {
  return /* @__PURE__ */ s(e.ResultsScrollArea, { children: [
    /* @__PURE__ */ t(e.ResultsScrollAreaViewport, { children: /* @__PURE__ */ t(e.ResultsList, { children: (n) => n.map((r) => /* @__PURE__ */ s(e.ResultsItem, { item: r, children: [
      /* @__PURE__ */ t(e.ResultsItemBreadcrumbs, { children: (l) => l.map((o, i) => /* @__PURE__ */ s(d, { children: [
        o,
        /* @__PURE__ */ t(e.ResultsItemBreadcrumbIcon, {})
      ] }, `${o}-${i}`)) }),
      /* @__PURE__ */ t(e.ResultsItemIcon, {}),
      /* @__PURE__ */ t(e.ResultsItemTitle, {}),
      /* @__PURE__ */ t(e.ResultsItemTag, {}),
      /* @__PURE__ */ t(e.ResultsItemDescription, { children: (l) => l.map((o, i) => /* @__PURE__ */ t(
        e.ResultsItemDescriptionPart,
        {
          part: o
        },
        `part-${i}`
      )) }),
      /* @__PURE__ */ t(e.ResultsItemIndicator, {})
    ] }, r.id)) }) }),
    /* @__PURE__ */ t(e.ResultsScrollAreaScrollbar, { children: /* @__PURE__ */ t(e.ResultsScrollAreaThumb, {}) }),
    /* @__PURE__ */ t(e.ResultsScrollAreaCorner, {})
  ] });
}
function O() {
  return /* @__PURE__ */ s(e.ResultsScrollArea, { children: [
    /* @__PURE__ */ t(e.ResultsScrollAreaViewport, { children: /* @__PURE__ */ s(e.ResultsItemPreview, { children: [
      /* @__PURE__ */ s(e.ResultsItemPreviewHeader, { children: [
        /* @__PURE__ */ s(e.ResultsItemPreviewHeading, { children: [
          /* @__PURE__ */ t(e.ResultsItemPreviewTitle, {}),
          /* @__PURE__ */ t(e.ResultsItemPreviewTitleLinkIcon, {})
        ] }),
        /* @__PURE__ */ t(e.ResultsItemPreviewBreadcrumbs, { children: (n) => n.map((r, l) => /* @__PURE__ */ s(d, { children: [
          r,
          /* @__PURE__ */ t(e.ResultsItemPreviewBreadcrumbIcon, {})
        ] }, `${r}-${l}`)) })
      ] }),
      /* @__PURE__ */ t(e.ResultsItemPreviewBody, {}),
      /* @__PURE__ */ s(e.ResultsItemPreviewOutline, { children: [
        /* @__PURE__ */ t(e.ResultsItemPreviewOutlineTitle, {}),
        /* @__PURE__ */ t(e.ResultsItemPreviewOutlineList, { children: (n) => n.map((r, l) => /* @__PURE__ */ s(
          e.ResultsItemPreviewOutlineItem,
          {
            href: r.url ?? void 0,
            "data-is-match": u(r.isMatch),
            children: [
              /* @__PURE__ */ t(e.ResultsItemPreviewOutlineItemIcon, {}),
              /* @__PURE__ */ t(e.ResultsItemPreviewOutlineItemText, { children: r.content }),
              r.url && /* @__PURE__ */ t(e.ResultsItemPreviewOutlineItemLinkIcon, {})
            ]
          },
          `${r.anchor}-${l}`
        )) })
      ] })
    ] }) }),
    /* @__PURE__ */ t(e.ResultsScrollAreaScrollbar, { children: /* @__PURE__ */ t(e.ResultsScrollAreaThumb, {}) }),
    /* @__PURE__ */ t(e.ResultsScrollAreaCorner, {})
  ] });
}
function $() {
  return /* @__PURE__ */ t(e.Footer, { children: /* @__PURE__ */ s(e.TaglineContainer, { children: [
    /* @__PURE__ */ t(e.TaglineText, {}),
    /* @__PURE__ */ t(e.TaglineLogo, {}),
    /* @__PURE__ */ t(e.TaglineBrandName, {})
  ] }) });
}
export {
  F as InkeepEmbeddedSearch,
  P as InkeepEmbeddedSearchImpl,
  b as InkeepEmbeddedSearchImplContent,
  k as InkeepEmbeddedSearchProvider
};
